import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pt0022',
    ecrans: ['00-2']
});
